module.exports = __webpack_public_path__ + "static/img/huehex-black.0bd077af.svg";